import { FC, useMemo } from 'react';
import { ProDatePicker } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import useRangePickerInterval from './hooks/useRangePickerInterval';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { RangePickerProps } from 'antd/lib/date-picker';
import { DEFAULT_DATA_FORMAT } from '../constants/constant';

export interface SearchFormRangePickerProps extends BaseSearchFormItemProps {
  /** rangePicker Props */
  rangePickerProps?: RangePickerProps;
}
/** 日期时间区间 */
export const SearchFormRangePicker: FC<SearchFormRangePickerProps> = props => {
  const {
    rangePickerProps,
    isDetail,
    form,
    isTable,
    testId,
    name,
    label,
    rules,
    render,
    disabledRender,
    ...resProps
  } = props;
  // @ts-ignore
  const currentFormat: string = rangePickerProps?.format || DEFAULT_DATA_FORMAT;
  const ranges = useRangePickerInterval(currentFormat);
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      test-id={`${testId}-${name}`}
      label={label}
      rules={rules}
    >
      {isDetail || (rangePickerProps && rangePickerProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          isMoment
          isTable={isTable}
          format={currentFormat}
          render={render || disabledRender}
        />
      ) : (
        <ProDatePicker.RangePicker
          style={{ width: '100%' }}
          format={DEFAULT_DATA_FORMAT}
          ranges={ranges}
          {...rangePickerProps}
          // placeholder={[getSelectPlaceholder(`${label}开始日期`, rangePickerProps, rules), getSelectPlaceholder(`${label}结束日期`, rangePickerProps, rules)]}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormRangePicker.displayName = SearchFormItemEnum.SearchFormRangePicker;

export default SearchFormRangePicker;
